module.exports = __webpack_public_path__ + "img/classicdrawing@2x.7882b3c.jpg";